// extracted by mini-css-extract-plugin
export default {"wrapper":"zj","centered":"Aj","gridWrapper":"Bj","grid":"Cj","oneColumn":"Dj","marginLeftAuto":"Ej"};